"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var inline_one_server_url_exports = {};
__export(inline_one_server_url_exports, {
  default: () => pluginInlineOneServerUrl
});
module.exports = __toCommonJS(inline_one_server_url_exports);
function pluginInlineOneServerUrl() {
  var serverUrl = process.env.ONE_SERVER_URL;
  return {
    visitor: {
      MemberExpression(nodePath) {
        var _node_object, _node_object_object, _node_object_property, _node_property;
        var { node } = nodePath;
        if (((_node_object = node.object) === null || _node_object === void 0 ? void 0 : _node_object.type) === "MemberExpression" && ((_node_object_object = node.object.object) === null || _node_object_object === void 0 ? void 0 : _node_object_object.name) === "process" && ((_node_object_property = node.object.property) === null || _node_object_property === void 0 ? void 0 : _node_object_property.name) === "env" && ((_node_property = node.property) === null || _node_property === void 0 ? void 0 : _node_property.name) === "ONE_SERVER_URL") {
          nodePath.replaceWith({
            type: "StringLiteral",
            value: serverUrl || ""
          });
        }
      }
    }
  };
}
//# sourceMappingURL=inline-one-server-url.js.map
